export default __webpack_public_path__ + "static/media/google-ads-icon-card.a67b819a.svg";